import { GetProductsByIdBatchedQuery } from '@notino/shared/definitions/types';
import { Product } from '@notino/web-tracking/dist/types/package/ga4/events/products';

import { dispatchTrackingEvent } from '@context/tracking/utils';
import { ProductEventWither } from '@helpers/googleTagManager';

export type WishlistActionLocation = 'product_detail' | 'wishlist' | 'list';

interface HandleTrackWishlistOperationParams {
  addedToWishlist: boolean;
  product: GetProductsByIdBatchedQuery['vpProductByIds'][number];
  timing: number;
  actionLocation: WishlistActionLocation;
  additionalPromoLabels?: string[];
  additionalGtm?: Partial<Product>;
}

export const handleTrackWishlistOperation = ({
  addedToWishlist,
  product,
  timing,
  actionLocation,
  additionalGtm = {},
  additionalPromoLabels = [],
}: HandleTrackWishlistOperationParams) => {
  const additionalData: Partial<Product> = Object.entries(additionalGtm).reduce(
    (acc, [key, value]) =>
      value === undefined ? acc : { ...acc, [key]: value },
    {}
  );

  if (addedToWishlist) {
    dispatchTrackingEvent({
      event: 'add_to_wishlist',
      wishlist: {
        action: 'product_added_to_wishlist',
        interaction: 'click_add',
        type: actionLocation,
        timing,
        products: [
          ProductEventWither()
            .withVpProduct(product)
            .withAdditionalPromoLabels(additionalPromoLabels)
            .withAdditionalData(additionalData)
            .build(),
        ],
      },
      _clear: true,
    });
  } else {
    dispatchTrackingEvent({
      event: 'remove_from_wishlist',
      wishlist: {
        action: 'product_removed_from_wishlist',
        interaction: 'click_remove',
        type: actionLocation,
        timing,
        products: [
          ProductEventWither()
            .withVpProduct(product)
            .withAdditionalData(additionalData)
            .build(),
        ],
      },
      _clear: true,
    });
  }
};
